import { useDispatch } from "react-redux";
import { uiActions } from "../../store";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./HelpModal.module.css";


export default function HelpModal() {
    const dispatch = useDispatch();

    const handleClose = function() {
        dispatch(uiActions.setHelpModalActive(false));
    } 

    return (
        <>
        <PopUpModal handleClose={handleClose}>
            <div className={styles.contentMain}>
            <h2>Help</h2>
            <div className={styles.content}>

                    <div className={styles.wrapIt}>
                        <h4>Select Floor Plan</h4>
                        <div className={styles.wBar}></div>
                        <p>Select a desired floor plan to begin visualizing.</p>
                    </div>
                    <div className={styles.wrapIt}>
                        <h4>Select Flooring</h4>
                        <div className={styles.wBar}></div>
                        <p>Select a product by type or color.</p>
                    </div>

                    <div className={styles.wrapIt}>
                        <h4>Apply Products</h4>
                        <div className={styles.wBar}></div>
                        <p>Select a product by filtering then selecting a product to apply to the scene.</p>
                    </div>

                    
                    <div className={styles.wrapIt}>
                        <h4>Compare</h4>
                        <div className={styles.wBar}></div>
                        <p>Click  <strong>Apply Left or Apply Right</strong> button to apply products to the selected side.<strong> Click Use this configuration and close </strong> button to see the applied product full screen. </p>
                    </div>


                    <div className={styles.wrapIt}>
                        <h4>Save Project</h4>
                        <div className={styles.wBar}></div>
                        <p>Click Save or My Projects to save your project.</p>
                    </div>

                    <div className={styles.wrapIt}>
                        <h4>Extras</h4>
                        <div className={styles.wBar}></div>
                        <p>Extra features include:Rotate, Undo, Redo, Share and Print.  </p>
                    </div>
                </div>
            </div>
        </PopUpModal>
        </>
    );
}
